// extracted by mini-css-extract-plugin
export default {"IdleModal":"IdleModal_IdleModal__KPqx2","Timer":"IdleModal_Timer__hEX1z","Inline":"IdleModal_Inline__6PE04"};